import { default as accedizdLO3DUxRBMeta } from "/opt/build/repo/pages/accedi.vue?macro=true";
import { default as index7qcPXZQ3fgMeta } from "/opt/build/repo/pages/admin/index.vue?macro=true";
import { default as index0XHO3NObntMeta } from "/opt/build/repo/pages/admin/registro/index.vue?macro=true";
import { default as index2whtqG3J39Meta } from "/opt/build/repo/pages/admin/trasparenza/in-attesa/index.vue?macro=true";
import { default as aiutoT0u2IHnzhrMeta } from "/opt/build/repo/pages/aiuto.vue?macro=true";
import { default as _91_91category_93_93JsxQqDwjsmMeta } from "/opt/build/repo/pages/categories/[[category]].vue?macro=true";
import { default as _91_46_46_46slug_93wVAoFJWNruMeta } from "/opt/build/repo/pages/docs/[...slug].vue?macro=true";
import { default as indexWLYLs65ZYpMeta } from "/opt/build/repo/pages/docs/index.vue?macro=true";
import { default as docs4hr4mD7LDxMeta } from "/opt/build/repo/pages/docs.vue?macro=true";
import { default as indexlaFeZuYZkUMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as index3EmdlvEK5AMeta } from "/opt/build/repo/pages/iniziative/natale/form/index.vue?macro=true";
import { default as grazieQR6wKi9sNIMeta } from "/opt/build/repo/pages/iniziative/natale/grazie.vue?macro=true";
import { default as iscrivi_45entezEo6j3BGxdMeta } from "/opt/build/repo/pages/iscrivi-ente.vue?macro=true";
import { default as iscriviti_altgAz1BVTue9Meta } from "/opt/build/repo/pages/iscriviti_alt.vue?macro=true";
import { default as iscrivitidSAWCySuKVMeta } from "/opt/build/repo/pages/iscriviti.vue?macro=true";
import { default as L124jn52jzS7XBMeta } from "/opt/build/repo/pages/L124.vue?macro=true";
import { default as opportunitaHre4gpKQ4FMeta } from "/opt/build/repo/pages/opportunita.vue?macro=true";
import { default as password_45dimenticataHtXT64azpoMeta } from "/opt/build/repo/pages/password-dimenticata.vue?macro=true";
import { default as cambio_45password4cbJ06n4T3Meta } from "/opt/build/repo/pages/profilo/cambio-password.vue?macro=true";
import { default as indexx2IW5JABHgMeta } from "/opt/build/repo/pages/profilo/index.vue?macro=true";
import { default as testsQ0rJvZrjqMeta } from "/opt/build/repo/pages/test.vue?macro=true";
import { default as _91year_938MkVNoIL0iMeta } from "/opt/build/repo/pages/trasparenza/[section]/[formName]/[year].vue?macro=true";
import { default as indexIADZn0sFQgMeta } from "/opt/build/repo/pages/trasparenza/[section]/[formName]/index.vue?macro=true";
import { default as indexfUKbUqJdWYMeta } from "/opt/build/repo/pages/trasparenza/[section]/index.vue?macro=true";
import { default as grazieb1juTjWWlYMeta } from "/opt/build/repo/pages/trasparenza/grazie.vue?macro=true";
import { default as indexIqTmyBqvYsMeta } from "/opt/build/repo/pages/trasparenza/index.vue?macro=true";
import { default as trasparenzavE8ygxVMBcMeta } from "/opt/build/repo/pages/trasparenza.vue?macro=true";
export default [
  {
    name: "accedi",
    path: "/accedi",
    meta: accedizdLO3DUxRBMeta || {},
    component: () => import("/opt/build/repo/pages/accedi.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: index7qcPXZQ3fgMeta || {},
    component: () => import("/opt/build/repo/pages/admin/index.vue")
  },
  {
    name: "admin-registro",
    path: "/admin/registro",
    meta: index0XHO3NObntMeta || {},
    component: () => import("/opt/build/repo/pages/admin/registro/index.vue")
  },
  {
    name: "admin-trasparenza-in-attesa",
    path: "/admin/trasparenza/in-attesa",
    meta: index2whtqG3J39Meta || {},
    component: () => import("/opt/build/repo/pages/admin/trasparenza/in-attesa/index.vue")
  },
  {
    name: "aiuto",
    path: "/aiuto",
    component: () => import("/opt/build/repo/pages/aiuto.vue")
  },
  {
    name: "categories-category",
    path: "/categories/:category?",
    component: () => import("/opt/build/repo/pages/categories/[[category]].vue")
  },
  {
    name: docs4hr4mD7LDxMeta?.name,
    path: "/docs",
    component: () => import("/opt/build/repo/pages/docs.vue"),
    children: [
  {
    name: "docs-slug",
    path: ":slug(.*)*",
    component: () => import("/opt/build/repo/pages/docs/[...slug].vue")
  },
  {
    name: "docs",
    path: "",
    component: () => import("/opt/build/repo/pages/docs/index.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "iniziative-natale-form",
    path: "/iniziative/natale/form",
    meta: index3EmdlvEK5AMeta || {},
    component: () => import("/opt/build/repo/pages/iniziative/natale/form/index.vue")
  },
  {
    name: "iniziative-natale-grazie",
    path: "/iniziative/natale/grazie",
    component: () => import("/opt/build/repo/pages/iniziative/natale/grazie.vue")
  },
  {
    name: "iscrivi-ente",
    path: "/iscrivi-ente",
    component: () => import("/opt/build/repo/pages/iscrivi-ente.vue")
  },
  {
    name: "iscriviti_alt",
    path: "/iscriviti_alt",
    meta: iscriviti_altgAz1BVTue9Meta || {},
    component: () => import("/opt/build/repo/pages/iscriviti_alt.vue")
  },
  {
    name: "iscriviti",
    path: "/iscriviti",
    meta: iscrivitidSAWCySuKVMeta || {},
    component: () => import("/opt/build/repo/pages/iscriviti.vue")
  },
  {
    name: "L124",
    path: "/L124",
    component: () => import("/opt/build/repo/pages/L124.vue")
  },
  {
    name: "opportunita",
    path: "/opportunita",
    component: () => import("/opt/build/repo/pages/opportunita.vue")
  },
  {
    name: "password-dimenticata",
    path: "/password-dimenticata",
    meta: password_45dimenticataHtXT64azpoMeta || {},
    component: () => import("/opt/build/repo/pages/password-dimenticata.vue")
  },
  {
    name: "profilo-cambio-password",
    path: "/profilo/cambio-password",
    component: () => import("/opt/build/repo/pages/profilo/cambio-password.vue")
  },
  {
    name: "profilo",
    path: "/profilo",
    component: () => import("/opt/build/repo/pages/profilo/index.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/opt/build/repo/pages/test.vue")
  },
  {
    name: trasparenzavE8ygxVMBcMeta?.name,
    path: "/trasparenza",
    component: () => import("/opt/build/repo/pages/trasparenza.vue"),
    children: [
  {
    name: "trasparenza-section-formName-year",
    path: ":section()/:formName()/:year()",
    meta: _91year_938MkVNoIL0iMeta || {},
    component: () => import("/opt/build/repo/pages/trasparenza/[section]/[formName]/[year].vue")
  },
  {
    name: "trasparenza-section-formName",
    path: ":section()/:formName()",
    meta: indexIADZn0sFQgMeta || {},
    component: () => import("/opt/build/repo/pages/trasparenza/[section]/[formName]/index.vue")
  },
  {
    name: "trasparenza-section",
    path: ":section()",
    component: () => import("/opt/build/repo/pages/trasparenza/[section]/index.vue")
  },
  {
    name: "trasparenza-grazie",
    path: "grazie",
    meta: grazieb1juTjWWlYMeta || {},
    component: () => import("/opt/build/repo/pages/trasparenza/grazie.vue")
  },
  {
    name: "trasparenza",
    path: "",
    component: () => import("/opt/build/repo/pages/trasparenza/index.vue")
  }
]
  }
]